import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { patchDomForBrowserExtensions } from 'shared';
import App from './App';
import '../../scss/application.scss';
patchDomForBrowserExtensions();
const container = document.getElementById('root');
const root = createRoot(container);
root.render(_jsx(App, {}));
